import React, { createContext, useContext, type ReactNode } from 'react';

export enum PageMode {
  BUILD = 'build',
  WORK = 'work',
}

export interface IPageContext {
  actor?: any;
  urlParams?: any;
  mode?: PageMode;
  [key: string]: any;
}

export const PageContext = createContext<IPageContext | undefined>(undefined);

interface IPageProviderProps {
  children: ReactNode;
  value: IPageContext;
}

export const PageProvider: React.FC<IPageProviderProps> = ({
  children,
  value,
}) => {
  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};

export const usePage = (): IPageContext => {
  const context = useContext(PageContext);

  if (context === undefined) {
    throw new Error('usePage must be used within a PageProvider');
  }

  return context;
};
